import React from 'react'


const BorderedSuccess2 = ({ color, width, height }) => {
  return (
    <svg width={width ||'28'} height={height || '28'} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M28 14.0151L25.6036 10.8935L26.1396 7.01514L22.482 5.56469L21.0315 1.90703L17.1532 2.44306L14 0.0151367L10.8784 2.41153L7 1.8755L5.54955 5.53315L1.89189 6.9836L2.42793 10.862L0 14.0151L2.3964 17.1368L1.86036 21.0151L5.51802 22.4656L6.96847 26.1232L10.8468 25.5872L13.9685 27.9836L17.0901 25.5872L20.9685 26.1232L22.4189 22.4656L26.0766 20.9836L25.5405 17.1052L28 14.0151ZM12.8649 18.5557L8.1982 14.7088L9.20721 13.4791L12.6757 16.3169L18.6036 9.4746L19.8018 10.5151L12.8649 18.5557Z" fill="#1088F8"/>
    </svg>

  )
}

export default BorderedSuccess2

